import {
  CREATE_NEW_USER_INIT,
  CREATE_NEW_USER_SUCCESS,
  CREATE_NEW_USER_FAILED,
  GET_ALL_USERS_INIT,
  GET_ALL_USERS_SUCCESS,
  GET_ALL_USERS_FAILED,
  GET_USER_DETAIL_INIT,
  GET_USER_DETAIL_SUCCESS,
  GET_USER_DETAIL_FAILED,
  UPDATE_USER_DETAIL_INIT,
  UPDATE_USER_DETAIL_SUCCESS,
  UPDATE_USER_DETAIL_FAILED,
  UPDATE_USER_STATUS_INIT,
  UPDATE_USER_STATUS_SUCCESS,
  UPDATE_USER_STATUS_FAILED,
  GET_USER_ROLES_INIT,
  GET_USER_ROLES_SUCCESS,
  GET_USER_ROLES_FAILED,
} from "./constants";
const initialState = {
  loading: false,
  createUsers: {},
  users: {},
  userDetail: {},
  updateStatus: {},
  updateUser: {},
  roles: [],
};

export default function createNewUsers(state = initialState, action) {
  switch (action.type) {
    case CREATE_NEW_USER_INIT:
      return { ...state, loading: true };
    case CREATE_NEW_USER_SUCCESS:
      return { ...state, loading: false, createUsers: action.payload };
    case CREATE_NEW_USER_FAILED:
      return { ...state, loading: false };

    case GET_ALL_USERS_INIT:
      return { ...state, loading: true };
    case GET_ALL_USERS_SUCCESS:
      return { ...state, loading: false, users: action.payload };
    case GET_ALL_USERS_FAILED:
      return { ...state, loading: false };

    case GET_USER_DETAIL_INIT:
      return { ...state, loading: true };
    case GET_USER_DETAIL_SUCCESS:
      return { ...state, loading: false, userDetail: action.payload };
    case GET_USER_DETAIL_FAILED:
      return { ...state, loading: false };

    case UPDATE_USER_DETAIL_INIT:
      return { ...state, loading: true };
    case UPDATE_USER_DETAIL_SUCCESS:
      return { ...state, loading: false, updateUser: action.payload };
    case UPDATE_USER_DETAIL_FAILED:
      return { ...state, loading: false };

    case UPDATE_USER_STATUS_INIT:
      return { ...state, loading: true };
    case UPDATE_USER_STATUS_SUCCESS:
      return { ...state, loading: false, updateStatus: action.payload };
    case UPDATE_USER_STATUS_FAILED:
      return { ...state, loading: false };
    case GET_USER_ROLES_INIT:
      return { ...state, loading: true };
    case GET_USER_ROLES_SUCCESS:
      return { ...state, loading: false, roles: action.payload };
    case GET_USER_ROLES_FAILED:
      return { ...state, loading: false };
    default:
      return state;
  }
}
